import { render, staticRenderFns } from "./BackToEditorButton.vue?vue&type=template&id=5cff860a&scoped=true&"
import script from "./BackToEditorButton.vue?vue&type=script&lang=js&"
export * from "./BackToEditorButton.vue?vue&type=script&lang=js&"
import style0 from "./BackToEditorButton.vue?vue&type=style&index=0&id=5cff860a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff860a",
  null
  
)

export default component.exports